// extracted by mini-css-extract-plugin
export default {"editorContainer":"Editor_editorContainer__EWDHa","textInput":"Editor_textInput__H+JXh"};